export default "__VITE_ASSET__BwbVJpF6__"